{
    "title": "Exchange",
    "subtitle": "Exchange currencies to your opened accounts. Check the operation fees and the remaining time for the exchange rate.",
    "availablebalance": "Available Balance",
    "remainingtime": "Remaining Time",
    "selectasset": "Select the asset you want to exchange",
    "insufficientfunds": "The amount is higher than the available balance",
    "above500k": "Amount above 500k is not allowed. Please contact the support for more information.",
    "description": "Description",
    "advice": "To use the exchange feature, you must have a crypto account opened.",
    "date": "Date",
    "amounttodebit": "Amount to Debit",
    "amounttocredit": "Amount to Credit",
    "fetchingrate": "Fetching Operation Rate...",
    "fees": {
        "operation": "Operation Fee",
        "crypto": "Crypto Exchange Fee",
        "rate": "Exchange Rate"
    },
    "modal":{
        "title": "Review Exchange"
    }
}